import script from "./PhotoUploadModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhotoUploadModal.vue?vue&type=script&setup=true&lang=ts"

import "./PhotoUploadModal.vue?vue&type=style&index=0&id=66a55357&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a55357"]])

export default __exports__